import React from "react";
import { iconMap } from '../../utils/icons';
import { typography, surfaces, borders, textColors, interactive } from "../../../design-system/tokens";

const allIcons = [
  { key: "none", label: "-" },
  // navigation / actions
  { key: "link", label: "Link" },
  { key: "external link", label: "External Link" },
  { key: "right arrow", label: "Right Arrow" },
  { key: "left arrow", label: "Left Arrow" },
  { key: "up arrow", label: "Up Arrow" },
  { key: "down arrow", label: "Down Arrow" },
  // common
  { key: "home", label: "Home" },
  { key: "mail", label: "Mail" },
  { key: "phone", label: "Phone" },
  { key: "download", label: "Download" },
  { key: "play", label: "Play" },
  { key: "pause", label: "Pause" },
  { key: "calendar", label: "Calendar" },
  { key: "location", label: "Location" },
  // brands
  { key: "scholar", label: "Google Scholar" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "tiktok", label: "TikTok" },
  { key: "github", label: "GitHub" },
  { key: "star", label: "Star" },
];

export default function IconPickerField({ label, help, value, onChange }) {
  const normalized = (value || "none").toLowerCase();

  return (
    <div className="field-wrapper">
      {label && <label className={`block mb-2 ${typography.label} ${textColors.secondary}`}>{label}</label>}
      <div className="grid grid-cols-3 gap-2">
        {allIcons.map((opt) => {
          const selected = normalized === opt.key || (normalized === "none" && opt.key === "none");
          const IconComp = iconMap[opt.key];
          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => onChange(opt.key === "none" ? "none" : opt.key.replace(/_/g, " "))}
              className={`flex items-center space-x-2 px-2 py-2 border rounded-xl transition-all ${typography.caption} ${
                selected 
                  ? `${interactive.selectedBg} text-white ${interactive.selectedBorder} shadow-sm` 
                  : `${borders.default} ${surfaces.tertiary} ${surfaces.hover}`
              }`}
            >
              <span className={`w-5 h-5 inline-flex items-center justify-center ${selected ? "text-white" : textColors.primary}`}>
                {IconComp ? <IconComp /> : <span>-</span>}
              </span>
              <span className={selected ? "text-white" : textColors.primary}>{opt.label}</span>
            </button>
          );
        })}
      </div>
      {help && <div className={`mt-2 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
}

// Back-compat for tests and callsites that import a named export.
export { IconPickerField };


